<div (click)="onToggle()" class="box-head">
  <a class="btn btn-link collapse-btn">
    {{ header }}
    <i *ngIf="isExpanded" class="fal fa-minus"></i>
    <i *ngIf="!isExpanded" class="fal fa-plus"></i>
  </a>
  <a
    *ngIf="hasEdit && canEdit"
    (click)="$event.stopPropagation(); edit.emit()"
    [matTooltip]="tooltipText"
    matTooltipPosition="above"
    matTooltipClass="text-center"
    class="edit-btn"
  >
    <i class="fal fa-edit"></i>
  </a>
</div>
<div [@expanded]="expanded" [class.collapsed]="!isExpanded" class="box-body collapse show">
  <ng-content></ng-content>
</div>
